import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  CopyLinkCircleOrange,
  deleteIconCircleOrange,
  eyeClose,
  faceBookCircleOrange,
  linkedInLinkCircleOrange,
  modalClose,
  moveIocn,
  pinIocn,
  whatsappCircleOrange,
  XCircleOrange,
} from "../../../../../images";
import { businessProfileViewURL2 } from "../../../../../components/helpers/constant-words";
import { toast } from "react-toastify";
import ToastMsg from "../../../../../components/ToastMsg/ToastMsg";
import config from "../../../../../config/config";

const SocialMediaLinksPopup = (props) => {
  const [animationClass, setAnimationClass] = useState("opening");
  // When modal opens, add "opening" class
  useEffect(() => {
    if (props.show) {
      setAnimationClass("opening");
    }
  }, [props.show]);

  // When modal is closing, delay actual close to complete animation
  const handleClose = () => {
    setAnimationClass("closing");
    setTimeout(() => {
      props.handleClose();
    }, 100); // Match animation duration
  };

  return (
    <>
      <Modal
        {...props}
        centered
        // className="Where_We_excel_popup"
        className={`Where_We_excel_popup ${animationClass} Bottom_sheet_options ${props.theme === "dark" && "Bottom_sheet_options--links-dark-mode"}`}
        backdropClassName="custom-backdrop"
        onHide={handleClose}
        // onExit={() => setIsClosing(true)}
      >
        <Modal.Header>
          <button className="custom-cancel-btn" onClick={handleClose}>
            <img
              src={modalClose}
              alt="close-icon"
              className="ctm_img_Where_We_excel_popup"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="bottom_options_wrapper">
            <a
              href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                props.shareTitle + " " + props.shareUrl
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="bottom_option"
            >
              <img
                src={whatsappCircleOrange}
                alt="Delete"
                className="bottom_option_img"
              />
              <div className="bottom_option_title">WhatsApp</div>
            </a>

            <a
              href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                props.shareUrl
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="bottom_option"
            >
              <img
                src={linkedInLinkCircleOrange}
                alt="Delete"
                className="bottom_option_img"
              />
              <div className="bottom_option_title">LinkedIn</div>
            </a>
            <a
              href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                props.shareTitle
              )}&url=${encodeURIComponent(props.shareUrl)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="bottom_option"
            >
              <img
                src={XCircleOrange}
                alt="Delete"
                className="bottom_option_img"
              />
              <div className="bottom_option_title">X</div>
            </a>
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                props.shareUrl
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="bottom_option"
            >
              <img
                src={faceBookCircleOrange}
                alt="Delete"
                className="bottom_option_img"
              />
              <div className="bottom_option_title">Facebook</div>
            </a>
            <div
              className="bottom_option border-0"
              onClick={() => {
                if (navigator.clipboard && window.isSecureContext) {
                  navigator.clipboard.writeText(props?.shareUrl).then(() => {
                    toast(
                      <ToastMsg message="Link copied to clipboard" />,
                      config.success_toast_config
                    );
                  });
                } else {
                  const textArea = document.createElement("textarea");
                  textArea.value = props?.shareUrl;
                  textArea.style.position = "fixed";
                  textArea.style.left = "-999999px";
                  document.body.appendChild(textArea);
                  textArea.focus();
                  textArea.select();
                  document.execCommand("copy");
                  textArea.remove();

                  toast(
                    <ToastMsg message="Link copied to clipboard" />,
                    config.success_toast_config
                  );
                }
              }}
              style={{ cursor: "pointer" }}
            >
              <img
                src={CopyLinkCircleOrange}
                alt="Delete"
                className="bottom_option_img"
              />
              <div className="bottom_option_title">Copy Link</div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SocialMediaLinksPopup;
